// Schmale Leiste am unteren Bildschirmrand - NUR auf dem Handy.
//
// Aufgabenteilung, damit nichts doppelt erscheint:
//   Handy   -> oben nur "Jetzt Ankauf anfragen", der direkte Draht sitzt hier
//              unten und ist IMMER da (siehe styles.css, dort werden die
//              Knoepfe "WhatsApp"/"Anrufen" im Startbereich ausgeblendet).
//   Rechner -> diese Leiste erscheint gar nicht, dort stehen alle drei
//              Knoepfe oben im Startbereich.
import React from "react";
import { useI18n } from "../I18nProvider";
import { whatsappLink } from "../whatsapp";
import IconWhatsApp from "./IconWhatsApp";

export default function HandyLeiste() {
  const { t } = useI18n();

  return (
    <div className="handy-leiste" role="group" aria-label={t("hero.cta_anruf")}>
      <a href="tel:+4917696084998" className="handy-leiste-knopf hl-anruf">
        <i className="fas fa-phone" aria-hidden="true"></i>
        {t("hero.cta_anruf")}
      </a>
      <a
        href={whatsappLink(t("hero.whatsapp_text"))}
        className="handy-leiste-knopf hl-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconWhatsApp />
        {t("hero.cta_whatsapp")}
      </a>
    </div>
  );
}
